import KunLoading75 from './src/index'

KunLoading75.install = function (Vue) {
	Vue.component(KunLoading75.name, KunLoading75);
}

export default KunLoading75;
